import {defaultLanguage} from '../../config/localization';
import {getPageDataKey} from "../util/cache/cachekeyRepository";

export default {
    getLanguageUrlPrefix(state) {
        return (locale) => (locale || state.locale) === defaultLanguage ? '' : `/${state.locale}`;
    },

    getMountedGameByAlias(state) {
        return (alias) => {
            let game = state.launchedGames.find(game => game.alias === alias);

            if (game && game.mounted) {
                return game;
            } else {
                return null;
            }
        };
    },

    getLayoutPagePart(state) {
        return (name) => state.layoutParts && state.layoutParts[name];
    },

    getPageData(state){
        return route => {
            let pageDataKey = getPageDataKey(route);

            return pageDataKey && state.pagesData[pageDataKey];
        }
    },

    getAvailableFortuneWheelSpinsCount(state){
        return () => state.fortuneWheels.reduce((count, fortuneWheel) => count + fortuneWheel.fortuneWheelSpins.length, 0);
    },
}
